<template>
  <div class="default-input" :class="{ focus: focus, disabled: disabled }">
    <label :for="id" class="input-wrapper">
      <span class="label m-subhead-m" :class="{ errorLabel: error }">
        {{ label }}
      </span>
      <input
        class="hidden"
        :id="id"
        @change="change"
        :placeholder="placeholder"
        type="file"
        ref="input"
        @focus="focus = true"
        @blur="focus = false"
        autocomplete="nope"
        :disabled="disabled"
      >
      <div class="m-body-m">
        {{ fileName }}
      </div>
    </label>
    <div class="icon">
      <img :src="require(`@/assets/icons/doc.svg`)" alt="icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileInput',
  methods: {
    change (event) {
      const [file] = event.target.files
      this.fileName = file.name
      this.$emit('input', file)
    }
  },
  props: {
    id: String,
    placeholder: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fileName: '',
      focus: false
    }
  }
}
</script>

<style lang="less" scoped>

.default-input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  height: 56px;
  border: 1px solid var(--grey-220);
  box-sizing: border-box;
  border-radius: var(--default-br);
  font-family: 'Montserrat';

  .icon {
    width: 16px;
    height: 16px;
    margin: 0 4px 0 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .input-wrapper {
    width: 100%;
  }

  .m-body-m {
    display: flex;
    align-items: center;
    padding: 0;
    width: 100%;
    height: 24px;
    border: none;
    color: var(--grey-180);
  }

  .label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 20px;
    color: var(--grey-140);
  }

  .label.errorLabel {
    color: var(--red);
  }

  &:hover {
    .label {
      color: var(--black);
    }
  }
}

.default-input.focus {
  border: 1px solid var(--second-base);
}

.default-input.disabled {
  background: var(--grey-240);
  cursor: not-allowed;
  filter: grayscale(100%);

  .label {
    color: var(--grey-200);
  }

  &:hover {
    .label {
      color: var(--grey-200);
    }
  }

  .m-body-m {
    color: var(--grey-200);
    cursor: not-allowed;
    background: none;
  }
}

.hidden {
  visibility: hidden;
  position: absolute;
  top: -100px;
  left: -100px;
}
</style>
